"use client";
import { useState } from "react";
import { Box, Typography } from "@mui/material";
import Image from "next/image";
import { makeStyles } from "tss-react/mui";
import { AppSize, pxToRem } from "@/util";
import { AppColors } from "@/assets/colors";
import { aboutSections } from "@/util/data/about";

export default function AboutDesign() {
  const { classes } = useStyles();
  const [activeTab, setActiveTab] = useState("mission");

  return (
    <Box className={classes.container}>
      {aboutSections.map((section) => (
        <Box
          key={section.id}
          className={`${classes.tab} ${
            activeTab === section.id ? classes.activeTab : ""
          }`}
          onClick={() => setActiveTab(section.id)}
          style={{
            background:
              activeTab === section.id ? section.bg : AppColors.neutral["80"],
            color: activeTab === section.id ? "#fff" : AppColors.primary["300"],
          }}
        >
          {/* Left side - Tab Title */}
          <Box className={classes.tabTitle}>
            <Box flex={1}>
              {" "}
              <Typography className={classes.number}>
                {section.number}
              </Typography>
            </Box>
            <Box className={classes.titleCont} flex={1}>
              <Typography className={classes.title}>{section.title}</Typography>
            </Box>
          </Box>

          {activeTab === section.id && (
            <Box className={classes.content}>
              <Box className={classes.line}></Box>

              <Box className={classes.main}>
                <Typography className={classes.title2}>
                  {section.title}
                </Typography>
                <Box className={classes.cont}>
                  <Typography className={classes.contentText}>
                    {section.content}
                  </Typography>
                </Box>
              </Box>

              <Image
                src={section.image}
                height="250"
                width="250"
                alt={section.title}
                className={classes.image}
              />
            </Box>
          )}
        </Box>
      ))}
    </Box>
  );
}

const useStyles = makeStyles()((theme) => ({
  container: {
    display: "flex",
    gap: theme.spacing(4),
    marginTop: theme.spacing(4),
    width: "100%",
    padding: `0px ${pxToRem(AppSize.padding)}`,
    [theme.breakpoints.down("sm")]: {
      border: "1px solid red",
    },
  },
  tab: {
    cursor: "pointer",
    flex: 1, // Each tab takes equal space
    height: pxToRem(433),
    display: "flex",
    flexDirection: "row",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(2),
    borderRadius: pxToRem(8),
    transition: "all 0.3s ease-in-out",
    backgroundColor: AppColors.neutral["80"],
    color: AppColors.primary["300"],
    fontWeight: 700,
    fontSize: pxToRem(25),
  },
  activeTab: {
    backgroundColor: "#4D3E24",
    color: "#fff",
    flex: 10, // Active tab takes 3x space of a normal tab
    height: pxToRem(433),
    padding: theme.spacing(3),
    overflow: "hidden",
  },
  cont: {
    height: pxToRem(270),
    overflow: "scroll",
    "&::-webkit-scrollbar": {
      display: "none",
    },
  },
  tabTitle: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "space-between",
    //backgroundColor:'red'
    // alignItems: "center",
    // textAlign: "center",
  },

  content: {
    marginTop: theme.spacing(2),
    textAlign: "justify",
    display: "flex",
  },
  contentText: {
    fontSize: pxToRem(20),
    lineHeight: "1.6",
    display: "flex",
    alignItems: "center",
    width: "90%",
  },
  image: {
    height: pxToRem(340),
    width: pxToRem(250),
    borderRadius: pxToRem(12),
    marginRight: pxToRem(35),
  },
  title2: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(25),
  },
  titleCont: {
    transform: "rotate(-90deg)",
    width: pxToRem(120), // Ensure enough width for longer text
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
  },
  title: {
    fontFamily: "Playfair Display",
    fontWeight: 700,
    fontSize: pxToRem(25),
    whiteSpace: "nowrap", // Prevents text wrapping
    textAlign: "center",
  },
  number: {
    fontSize: pxToRem(25),
    fontFamily: "Playfair Display",
    fontWeight: 700,
    transform: "rotate(-90deg)",
  },
  line: {
    height: pxToRem(344.5),
    border: `1px solid ${theme.colors.gray}`,
  },
  main: {
    display: "flex",
    flexDirection: "column",
    paddingLeft: theme.spacing(4),
    gap: theme.spacing(4),
  },
}));
